{
  "title": "活動平台總覽",
  "description": "平台的活動頁提供哪些服務、誰可以使用、與競賽有何不同，以及資料如何被保護。",
  "headings": [
    "你會了解什麼",
    "適用對象",
    "先了解",
    "服務一覽",
    "重點保證",
    "常見問題"
  ],
  "summary": "活動平台是與競賽並行的另一組功能，為研討會等活動提供現場服務，例如 TAAI 2026。報名、付款與宴會資格仍以官方報名系統為準，本平台只提供補充服務。",
  "roleNote": "與會者、活動工作人員、平台管理員",
  "prerequisites": [
    "活動頁從主導覽「活動」進入，網址為 /events 與 /events/:slug",
    "活動與競賽的身分、資料與授權彼此獨立：不需要參賽也能使用活動服務，競賽主辦方或評審也不會自動取得活動權限",
    "多數服務需登入並驗證 Email；接駁車預約另可只用 Email 完成"
  ],
  "pathLabel": "主導覽 → 活動 → 選擇活動",
  "steps": [
    {
      "title": "1. 免費接駁車預約",
      "description": "依日期與班次預約座位，可只用 Email 或登入後預約，一次最多 4 席（本人加最多 3 位同行者），各自有乘車 QR。額滿可候補，有人取消時依序自動遞補並通知。預約與取消於發車前 12 小時截止。詳見「如何預約活動接駁車」。"
    },
    {
      "title": "2. 現場 QR 驗票與乘客名單",
      "description": "工作人員以相機或貼上憑證驗票，網路不穩時可暫存在裝置上，恢復後同步；伺服器為準，同一張 QR 只會成功一次。乘客名單供人工核對，不含行動電話。詳見「如何在活動現場驗票與核對乘客名單」。"
    },
    {
      "title": "3. 餐飲與宴會回覆",
      "description": "回覆午餐出席、飲食類別與宴會出席，供主辦單位估算人數；宴會回覆不是宴會資格，也不是付款證明。詳見「如何回覆餐飲宴會與使用客服」。"
    },
    {
      "title": "4. 公告與服務台",
      "description": "主辦單位發布中英文雙語公告（一般、重要、緊急），並可對持有接駁預約者寄出 Email 通知；與會者可向服務台送出案件並追蹤狀態。"
    },
    {
      "title": "5. 志工、海報與講者",
      "description": "主辦單位以 Email 指派志工班表；海報發表者可申請設備；講者可上傳 PDF 或 PPTX 簡報，檔案一律先隔離，經主辦單位審核後才可下載。"
    },
    {
      "title": "6. 活動成員與主辦方後台",
      "description": "主辦單位以 Owner、Manager、Scanner、Viewer 四種角色分配最小必要的權限，並在後台看到預約、候補與驗票的即時統計。詳見「如何管理活動成員與主辦方後台」。"
    },
    {
      "title": "7. 活動成員各自能做什麼",
      "description": "Owner：全部功能，含成員管理、營運工具與緊急聯絡電話。Manager：公告、Email 通知、餐飲匯出與服務台案件。Scanner：接駁車驗票與乘客名單。Viewer：只看報表。成員以已驗證的 Email 加入，可先加入、註冊並驗證後生效；單一活動最多 50 位，最後一位 Owner 不能被移除或降級。競賽主辦方不會自動成為活動成員。"
    },
    {
      "title": "8. 平台管理員的角色",
      "description": "平台超級管理員對所有已發布活動視同 Owner，可進入後台與營運工具。活動的成員異動、公告、案件狀態、餐飲匯出、緊急聯絡電話查看與講者檔案審核都有獨立的稽核紀錄。平台管理員等特權帳號不能經 Email 連結預約，須以一般方式登入。活動由平台建立，並由平台維持資料自動清除與保存的規則。完整說明見平台管理操作手冊的活動章節。"
    }
  ],
  "afterward": [
    "座位不會超賣；同一人同一天同一方向最多一筆有效預約",
    "需要的個資只限乘車核對與緊急聯絡：驗票人員只見姓名、單位、職稱，行動電話僅活動 Owner 在緊急時可查看並留有紀錄，飲食備註加密保存",
    "乘車聯絡、餐飲與提醒資料於活動結束後 30 天自動刪除",
    "活動頁的畫面隱藏不是安全邊界，所有權限都在伺服器端判斷"
  ],
  "nextSteps": "想預約接駁車請見「如何預約活動接駁車」；想了解資料處理請見隱私權說明與資料保存政策；完整操作請見各角色操作手冊的活動章節。",
  "faq": [
    {
      "q": "活動平台和競賽有什麼不同？",
      "a": "競賽處理報名組隊、作品繳交、評審與結果；活動處理現場服務，例如接駁車、餐飲與客服。兩者資料與權限分開，也不共用角色。"
    },
    {
      "q": "我需要註冊帳號嗎？",
      "a": "瀏覽活動資訊不需要。預約接駁車可只用 Email，開啟確認連結後才保留座位並同時登入；餐飲回覆與客服需登入。"
    },
    {
      "q": "平台會處理報名與付款嗎？",
      "a": "不會。報名、付款與宴會資格以官方報名系統為準；平台不提供票務、付款、退款或課程功能。"
    },
    {
      "q": "哪些活動可以使用？",
      "a": "目前為 TAAI 2026（/events/taai-2026）。活動由平台管理方建立，目前沒有自助建立活動的畫面。"
    }
  ]
}
